import { Inject, Injectable, PLATFORM_ID } from '@angular/core';
import { ResolveStart, Router } from '@angular/router';
import { BehaviorSubject, filter, map, Observable } from 'rxjs';

import { UaService } from '@ecm/consumer';
import { RouterService, ToggleService } from '@ecm/router';

const LOCALSTORAGE_KEY = 'smartbanner';
const EXPIRATION_DELAY_IN_MS = 30 * 24 * 60 * 60 * 1000;

@Injectable({
    providedIn: 'root',
})
export class SmartbannerStoreService {
    private _isDisplayed$ = new BehaviorSubject<boolean>(false);

    public constructor(
        @Inject(PLATFORM_ID) protected platformId: any,
        protected router: Router,
        protected toggleService: ToggleService,
        protected routerService: RouterService,
        protected uaService: UaService,
    ) {} /**/

    /*COMMANDS*/
    public enter(): void {
        this.router.events
            .pipe(
                filter((e): boolean => e instanceof ResolveStart),
                map((e: ResolveStart) => {
                    let child = e?.state?.root?.firstChild;
                    while (child) {
                        if (child.firstChild) {
                            child = child.firstChild;
                        } else if (child.data && child.data.smartbanner) {
                            return child.data.smartbanner;
                        } else {
                            return null;
                        }
                    }
                    return null;
                }),
            )
            .subscribe((data: any) => {
                const toggleKey = 'DASHBOARD.SMARTBANNER';
                this.toggleService.getFeatureStatus(toggleKey).subscribe((isDisplayed: boolean) => {
                    if (!isDisplayed) {
                        this._isDisplayed$.next(false);
                        return;
                    }

                    if (!this.uaService.isMobile() && !this.uaService.isTablet()) {
                        this._isDisplayed$.next(false);
                        return;
                    }
                    /* UC : we must have a data smartbanner tag in route to display smartbanner*/
                    if (!data) {
                        this._isDisplayed$.next(false);
                        return;
                    }
                    this._isDisplayed$.next(this.isExpired());
                });
            });
    }

    public close(): void {
        localStorage.setItem(LOCALSTORAGE_KEY, new Date().toISOString());
        this._isDisplayed$.next(false);
    }

    public navigateToApp(url: string): void {
        localStorage.setItem(LOCALSTORAGE_KEY, new Date().toISOString());
        this._isDisplayed$.next(false);
        // Use scheme url
        this.routerService.redirectToExternalUrl(url);
    }

    /*QUERY*/
    public get isDisplayed$(): Observable<boolean> {
        return this._isDisplayed$.asObservable();
    }

    /* METHODS */
    public isExpired(): boolean {
        const today = new Date();
        const storageDate = localStorage?.getItem(LOCALSTORAGE_KEY);
        if (storageDate) {
            // Storage Date + 30 jours
            const expiredDate = new Date(storageDate).getTime() + EXPIRATION_DELAY_IN_MS;
            const delta = Math.floor(today.getTime() - expiredDate);
            if (delta > 0) {
                localStorage.removeItem(LOCALSTORAGE_KEY);
                return true;
            } else {
                return false;
            }
        } else {
            return true;
        }
    }
}
